import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-259d05a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "two-column-section",
  id: "two-column-section"
}
const _hoisted_2 = { class: "column column-one" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  class: "column column-two",
  id: "column-two"
}
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheFormCreditDataSlider = _resolveComponent("TheFormCreditDataSlider")!
  const _component_TheFormUserData = _resolveComponent("TheFormUserData")!
  const _component_Wizard = _resolveComponent("Wizard")!
  const _component_TheSuccessForm = _resolveComponent("TheSuccessForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "side-img",
        src: require('@/assets/' + _ctx.imageFileName),
        alt: _ctx.altText
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.requestSucceeded == false)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_5, _toDisplayString(_ctx.titleForm), 1))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        id: "form-request",
        class: "wrapper-form",
        onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
        ref: "div-1"
      }, [
        _withDirectives(_createVNode(_component_TheFormCreditDataSlider, {
          onFormButtonClicked: _ctx.goNextStep,
          onValuesChanged: _ctx.creditDataChanged,
          limit: _ctx.limit,
          installment: _ctx.installment
        }, null, 8, ["onFormButtonClicked", "onValuesChanged", "limit", "installment"]), [
          [_vShow, !_ctx.nextStep]
        ]),
        _withDirectives(_createVNode(_component_TheFormUserData, {
          onSubmitForm: _ctx.submitUser,
          onBackStep: _ctx.backStepClicked,
          enableMessage: _ctx.enableMessage,
          messageResponse: _ctx.messageResponse,
          class: "form-data"
        }, null, 8, ["onSubmitForm", "onBackStep", "enableMessage", "messageResponse"]), [
          [_vShow, _ctx.nextStep && _ctx.requestSucceeded == false]
        ]),
        _createVNode(_component_Wizard, {
          class: "circles-wizard",
          list: [_ctx.statusStepOne, _ctx.nextStep]
        }, null, 8, ["list"]),
        (_ctx.requestSucceeded === true)
          ? (_openBlock(), _createBlock(_component_TheSuccessForm, {
              key: 0,
              buttonLabel: "ENVIAR",
              onNewRequestClicked: _ctx.newRequestClicked,
              onRateClicked: _ctx.submitStarRate,
              useRatingChips: true,
              useRateStar: true,
              userData: _ctx.userData
            }, null, 8, ["onNewRequestClicked", "onRateClicked", "userData"]))
          : _createCommentVNode("", true)
      ], 544)
    ])
  ]))
}